<template>
  <div>
    <CustCard
      :title="$l('form_header_businessSet') || '业务设置'"
      :desc="
        $l('form_desc_businessSet') || '客户服务团队人员配置，相关业务参数设置'
      "
      style="margin-bottom: 10px;"
    >
      <CustTakeOrder :custCode="custCode" />
    </CustCard>

    <CustCard
      :title="$l('form_header_sales') || '团队设置'"
      :desc="$l('form_desc_sales') || '服务客户的团队成员配置'"
      style="margin-bottom: 10px;"
    >
      <CustSales :custCode="custCode" />
    </CustCard>

    <CustCard
      :title="$l('form_header_factoryInfo') || '验厂相关'"
      :desc="$l('form_desc_factoryInfo') || '客户对验厂相关要求'"
    >
      <CustFactory :custCode="custCode" />
    </CustCard>
  </div>
</template>

<script>
import CustTakeOrder from '../cust-take-order'
import CustSales from '../cust-sales'
import CustFactory from '../cust-factory'
import CustCard from '../cust-card'
export default {
  components: { CustTakeOrder, CustSales, CustFactory, CustCard },
  props: { custCode: { type: String, default: '' } },
}
</script>
